import { useLingui } from '@lingui/react/macro'
import Link from 'next/link'

export const Resources = () => {
	const { t } = useLingui()

	return (
		<ul className='flex flex-col'>
			<li className='mb-1 font-bold'>{t`Ressources`}</li>

			<li>
				<Link
					href='/blog'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					{t`Blog`}
				</Link>
			</li>

			<li>
				<Link
					href='/use-cases'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					{t`Cas clients`}
				</Link>
			</li>
		</ul>
	)
}
